import { render } from "./event_transportation_quantity.vue?vue&type=template&id=7246f2ed"
import script from "./event_transportation_quantity.vue?vue&type=script&lang=js"
export * from "./event_transportation_quantity.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__